import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import Logo from './Logo';

const PayRedirect: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'loading' | 'redirecting' | 'error'>('loading');
  const [errorMsg, setErrorMsg] = useState('');
  const [tikkieUrl, setTikkieUrl] = useState('');

  useEffect(() => {
    const run = async () => {
      const eventId = searchParams.get('event');
      const email = searchParams.get('email');

      if (!eventId || !email) {
        setErrorMsg('Ongeldige link. Controleer de link in je e-mail.');
        setStatus('error');
        return;
      }

      try {
        await supabase.from('payment_clicks').insert({ event_id: eventId, email });
      } catch {
        // silent
      }

      try {
        let redirectUrl: string | null = null;

        const { data: eventData } = await supabase
          .from('events')
          .select('tikkie_url')
          .eq('id', eventId)
          .maybeSingle();

        if (eventData?.tikkie_url) {
          redirectUrl = eventData.tikkie_url;
        } else {
          const { data: defaultData, error: defaultError } = await supabase
            .from('tikkie_urls')
            .select('url')
            .is('expired_at', null)
            .maybeSingle();

          if (!defaultError && defaultData?.url) {
            redirectUrl = defaultData.url;
          }
        }

        if (!redirectUrl) {
          setErrorMsg('Er is geen betaallink beschikbaar. Neem contact op via info@sisterhoodmemberclub.nl.');
          setStatus('error');
          return;
        }

        setTikkieUrl(redirectUrl);
        setStatus('redirecting');
        window.location.replace(redirectUrl);
      } catch {
        setErrorMsg('Er is een fout opgetreden. Probeer het opnieuw of neem contact op.');
        setStatus('error');
      }
    };

    run();
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-[#FDF8F5] flex flex-col items-center justify-center px-4">
      <div className="mb-8">
        <Logo className="h-12 w-auto" />
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 max-w-sm w-full text-center">
        {status === 'loading' && (
          <>
            <div className="w-10 h-10 border-2 border-[#E37C64] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
            <p className="text-gray-600">Bezig met laden...</p>
          </>
        )}
        {status === 'redirecting' && (
          <>
            <div className="w-10 h-10 border-2 border-[#E37C64] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
            <p className="text-gray-800 font-medium mb-1">Je wordt doorgestuurd</p>
            <p className="text-sm text-gray-500 mb-4">Je wordt nu doorgestuurd naar de betaalpagina.</p>
            {tikkieUrl && (
              <a
                href={tikkieUrl}
                className="inline-block mt-2 text-sm text-[#5A130E] underline underline-offset-2"
              >
                Klik hier als je niet automatisch wordt doorgestuurd
              </a>
            )}
          </>
        )}
        {status === 'error' && (
          <>
            <p className="text-[#5A130E] font-medium mb-2">Er is iets misgegaan</p>
            <p className="text-sm text-gray-500">{errorMsg}</p>
          </>
        )}
      </div>
    </div>
  );
};

export default PayRedirect;
